import React, { Fragment } from 'react'
import { BrowserRouter as Router, Route } from "react-router-dom";

import {
  WelcomeScreen,
  HomeScreen,
  NameScreen,
  QuizScreen,
  ResultScreen,
} from './../screens'

export default () => (
  <Router>
    <Fragment>
      <Route exact path="/" component={HomeScreen} />
      <Route exact path="/Name" component={NameScreen} />
      <Route exact path="/Home" component={WelcomeScreen} />
      <Route exact path="/Play" component={QuizScreen} />
      <Route exact path="/Result" component={ResultScreen} />
    </Fragment>
  </Router>
)



// WEBPACK FOOTER //
// ./src/navigation/RootNavigator.js